import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { UtilsService } from "../../services/utils.service";
import { DatePipe } from '@angular/common';
import { HistoryComponent } from "../history/history.component";
import { ModalHelper } from "../../components/modal/modal.helper";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChatService } from "../../services/chat.service";
import { BusinessEventService } from "../../services/business-event.service";
var ListComponent = (function () {
    function ListComponent(_data, _blogic, _modal, _utils, _bevent, _chat, datePipe) {
        var _this = this;
        this._data = _data;
        this._blogic = _blogic;
        this._modal = _modal;
        this._utils = _utils;
        this._bevent = _bevent;
        this._chat = _chat;
        this.datePipe = datePipe;
        this.defaultOptions = {
            noShow: true,
            inWait: true,
            redirect: true,
            finished: false,
            return: true,
            inAttention: false,
            cancelled: true
        };
        this.filters = {
            clientname: "",
            clientid: "",
            label: "",
            desk_id: "",
            prekind_id: "",
            planhour: ""
        };
        this.options = {};
        this.selectedQueue = null;
        this.queues = [];
        this.queuesnotempty = [];
        this.idTurns = [];
        this.cancelledTurns = [];
        this.selected = null;
        this.orderType = null;
        this.orderReverse = false;
        this.columnLoaded = false;
        this.printed = true;
        this.tprinting = 0;
        this.actualDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss').toString();
        this.isFiltered = false;
        this.socketRetries = 0;
        this.listFilter = { label: '' };
        this.search = '';
        this.columns = {};
        this.defaultColumns = [
            { name: "plandate", visible: false, lang: "planDate" },
            { name: "planhour", visible: true, lang: "hour" },
            { name: "label", visible: true, lang: "turn" },
            { name: "clientid", visible: true, lang: "cclient" },
            { name: "clientname", visible: true, lang: "client" },
            { name: "ccode", visible: false, lang: "ccode" },
            { name: "type", visible: false, lang: "status" },
            { name: "prekindname", visible: true, lang: "actualKind" },
            { name: "task", visible: false, lang: "task" },
            { name: "initdatetime", visible: true, lang: "ticketDate" },
            { name: "lastredirect", visible: true, lang: "redirectDate" },
            { name: "deskdatetime", visible: true, lang: "attentionDate" },
            { name: "deskname", visible: true, lang: "desk" },
            { name: "rdcomment", visible: true, lang: "observations" },
            { name: "queuename", visible: true, lang: "queue" },
            { name: "attime", visible: false, lang: "attime" },
            { name: "waittime", visible: false, lang: "waittime" }
        ];
        this.visibleColumns = [];
        this.destroy$ = new Subject();
        this.sortableOptions = {
            onUpdate: function (event) {
                _this.saveColumns();
            }
        };
    }
    ListComponent.prototype.ngOnInit = function () {
        var _this = this;
        $(document).on("click", ".dropdown-menu", function (e) {
            e.stopPropagation();
        });
        this.initIoConnection();
        this._blogic.turnInProgress = false;
        if (localStorage.getItem("columns") != null) {
            this.columns = JSON.parse(localStorage.getItem("columns"));
        }
        else {
            var defaultColumns = this.defaultColumns;
            this.columns = defaultColumns;
        }
        if (localStorage.getItem("colours") != null) {
            this.options = JSON.parse(localStorage.getItem("colours"));
        }
        else {
            var defaultOptions = this.defaultOptions;
            this.options = defaultOptions;
        }
        if (localStorage.getItem("filters") != null) {
            this.filters = JSON.parse(localStorage.getItem("filters"));
            this.isFiltered = true;
        }
        if (localStorage.getItem("search") != null) {
            this.search = localStorage.getItem("search");
            this.searchFilter();
        }
        this.checkVisibleColumns();
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.selected = null;
            _this.getTurnList();
        });
        this.getQueueList();
        if (this._data.saveQueue) {
            this.getTurnList();
        }
        if (localStorage.getItem("orderType") !== null) {
            this.orderType = localStorage.getItem("orderType");
        }
        if (localStorage.getItem("orderReverse") !== null) {
            this.orderReverse = JSON.parse(localStorage.getItem("orderReverse"));
        }
    };
    ListComponent.prototype.clearResetIntervals = function () {
        /* clearInterval(this.intervalTList);
    
         if(this.selectedQueue)
         this.intervalTList = setInterval(() => {
           this.getTurnList();
         }, this._data.configuration["secsCheckQueue"]);*/
    };
    ListComponent.prototype.initIoConnection = function () {
        var _this = this;
        if (this.socketRetries != null)
            this.socketRetries++;
        if (this.subscriptionClose != null)
            this.subscriptionClose.unsubscribe();
        if (this.subscriptionOpen != null)
            this.subscriptionOpen.unsubscribe();
        if (this.ioConnection != null)
            this.ioConnection.unsubscribe();
        this.ioConnection = this._bevent.onMessage()
            .subscribe(function (response) {
            if (response["eventhook"] == "viewerfb") {
                _this._data.turnStatusInViewer.unshift(response["message"]);
                _this._data.turnStatusInViewer = _this._data.turnStatusInViewer.slice(0, 100);
            }
            if (response["eventhook"] == "disconect") {
                _this._data.deskInUseDeskName = response["message"]["desk_name"];
                _this._data.deskInUseHostAddr = response["message"]["hostaddr"];
                _this._data.deskInUseOffice = response["message"]["office"];
                _this._data.deskInUseDate = response["message"]["logindate"];
                _this._data.deskInUseHour = response["message"]["logintime"];
                _this._data.deskInUse = true;
            }
            if (response["eventhook"] == "force_disconect") {
                _this.softLogout();
            }
            if (response["eventhook"] == "turninfo") {
                _this.queues = response["message"]["qinfo"];
                _this.changeMode();
                if (_this.selectedQueue)
                    _this.getTurnList();
            }
        });
        this.subscriptionOpen = this._bevent.onOpen()
            .subscribe(function (response) { });
        this.subscriptionClose = this._bevent.onClose()
            .subscribe(function (response) {
            _this.initIoConnection();
        });
    };
    ListComponent.prototype.showAlert = function (value) {
        this.subscriptionClose.unsubscribe();
        this.subscriptionOpen.unsubscribe();
        this.ioConnection.unsubscribe();
        this._bevent.close();
        this.socketRetries = null;
    };
    ListComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.intervalQueue);
        clearInterval(this.intervalTList);
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Get queue list */
    ListComponent.prototype.getQueueList = function () {
        var _this = this;
        var params = { filter: "queue" };
        this._blogic.getQueueList(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._blogic.lastQueueList = response;
            _this._blogic.queueInProgress = false;
            _this.queues = response;
            if (_this._data.saveQueue == null) {
                _this.selectedQueue = null;
            }
            else {
                _this.selectedQueue = _this._data.saveQueue;
            }
            _this.changeMode();
        });
    };
    ListComponent.prototype.printTicket = function (turn_id) {
        var _this = this;
        this.printed = false;
        this.tprinting = turn_id;
        var params = { turn_id: turn_id };
        this._blogic.printTicket(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.getTurnList();
        });
    };
    /* Check if work with 1 queue or more */
    ListComponent.prototype.changeMode = function () {
        var split = this._data.session["schemaitms"].split(",");
        var allQueues = this.queues;
        this.queues = [];
        var count = 0;
        for (var i = 0; i < allQueues.length; i++) {
            if (split.indexOf(allQueues[i].id.toString()) !== -1) {
                this.queues.push(allQueues[i]);
                count++;
            }
        }
        this.queuesnotempty = this.queues.filter(function (q) { return q.size > 0 || q.nturns > 0; });
        if (count <= 1) {
            this.selectedQueue = this.queues[0].id;
            this._data.saveQueue = this.selectedQueue;
            this.getTurnList();
        }
    };
    ListComponent.prototype.getSerializedQueueList = function () {
        var qs = "";
        this.queues.forEach(function (element) {
            qs += element.id;
            qs += ",";
        });
        return qs.substr(0, qs.length - 1);
    };
    /* Get queue list */
    ListComponent.prototype.getTurnList = function () {
        var _this = this;
        if (this.selectedQueue != null) {
            this._data.saveQueue = this.selectedQueue;
            var params = {
                queue_id: this.selectedQueue,
                session_id: this._data.session["session"]
            };
            if (this.selectedQueue == 'all')
                params["assignedQueue"] = this.getSerializedQueueList();
            else
                params["queue_id"] = this.selectedQueue;
            if (this._blogic.turnInProgress && this._blogic.lastQueueData) {
                this._blogic.turns = this.filter(this._blogic.lastQueueData);
                return;
            }
            this.getTurnListSub = this._blogic.getTurnList(params, true)
                .pipe(takeUntil(this.destroy$))
                .subscribe(function (response) {
                _this._blogic.lastQueueData = response;
                _this._blogic.turnInProgress = false;
                _this.actualDate = _this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss').toString();
                for (var e = 0; e < response.length; e++) {
                    if (response[e]['lastredirect'] != null && !(typeof response[e]['lastredirect'] == 'number') && !_this.isFinished(e)) {
                        response[e]['lastredirect'] = _this._utils.getWaitTime(response[e]['lastredirect'], _this.actualDate, false, true);
                    }
                    else if (response[e]['lastredirect'] == null && !_this.isFinished(response[e])) {
                        response[e]['lastredirect'] = _this._utils.getWaitTime(response[e]['initdatetime'], _this.actualDate, false, true);
                    }
                    else if (_this.isFinished(e) || _this.isRedirect(e)) {
                        response[e]['lastredirect'] = "0 min";
                    }
                    else { }
                }
                _this._blogic.turns = _this.filter(response);
                _this.orderBy(_this.orderType, true);
                _this.printed = true;
            });
        }
    };
    ListComponent.prototype.selectTurn = function (t) {
        if (this.isCancelled(t)) {
            t["type"] = "cancelled";
        }
        if (this.isNoShow(t)) {
            t["type"] = "noShow";
        }
        if (this.isInWait(t)) {
            t["type"] = "inWait";
        }
        if (this.isRedirect(t)) {
            t["type"] = "redirect";
        }
        if (this.isFinished(t)) {
            t["type"] = "finished";
        }
        if (this.isInAttention(t)) {
            t["type"] = "inAttention";
        }
        if (t.fqueue_id == this.selectedQueue || t.queue_id == this.selectedQueue || this.selectedQueue == 'all') {
            this._data.selectedTurn = t;
        }
        else {
            this._data.selectedTurn = null;
        }
    };
    ListComponent.prototype.isNoShow = function (t) {
        return (this.options["noShow"] && (t.printed == false && t.deskdatetime == null));
    };
    ListComponent.prototype.isInWait = function (t) {
        return ((this.options["inWait"] &&
            t.deskdatetime == null &&
            t.printed == true && t.canceldatetime == null &&
            (t.queue_id == this.selectedQueue || this.selectedQueue == "all")) ||
            ((t.lastredirect != null && t.queue_id == this.selectedQueue && !this.isFinished(t) && t.lqueue_id != '-1' && !this.isInAttention(t))
                && this.isCancelled(t)));
    };
    ListComponent.prototype.isRedirect = function (t) {
        return (this.options["redirect"] &&
            (t.lastredirect != null &&
                (t.enddatetime == null || (t.enddatetime != null && t.queue_id != this.selectedQueue && this.selectedQueue != "all")) &&
                (t.queue_id != this.selectedQueue && this.selectedQueue != "all")));
    };
    ListComponent.prototype.isFinished = function (t) {
        return this.options["finished"] && t.enddatetime != null;
    };
    ListComponent.prototype.isInAttention = function (t) {
        return (this.options["inAttention"] && ((t.deskdatetime != null && t.enddatetime == null && t.queue_id == this.selectedQueue) || (t.deskdatetime != null && t.enddatetime == null && this.selectedQueue == "all")));
    };
    ListComponent.prototype.isCancelled = function (t) {
        return (this.options["cancelled"] && t.deskdatetime == null && t.printed == true && t.canceldatetime != null);
    };
    ListComponent.prototype.getVisibleColums = function () {
        return this.columns.filter(function (c) { return c.visible == true; });
    };
    ListComponent.prototype.getFirstVisibleColum = function () {
        var vcolums = this.getVisibleColums();
        return (vcolums) ? vcolums[0] : null;
    };
    ListComponent.prototype.checkColumsVisible = function (type) {
        var c = this.columns.filter(function (c) { return c.visible == true && c.name == type; });
        return c ? true : false;
    };
    ListComponent.prototype.orderBy = function (type, onlyRefresh) {
        if (onlyRefresh === void 0) { onlyRefresh = false; }
        this.orderType = type;
        localStorage.setItem("orderType", type);
        if (!onlyRefresh) {
            this.orderReverse = !this.orderReverse;
        }
        localStorage.setItem("orderReverse", JSON.stringify(this.orderReverse));
    };
    ListComponent.prototype.saveColumns = function () {
        localStorage.setItem("columns", JSON.stringify(this.columns));
        this.checkVisibleColumns();
    };
    ListComponent.prototype.saveOptions = function () {
        localStorage.setItem("colours", JSON.stringify(this.options));
    };
    ListComponent.prototype.resetColumns = function () {
        localStorage.removeItem("columns");
        localStorage.removeItem("colours");
        this.ngOnInit();
        location.reload();
    };
    /* Hace un listado con las diferentes columnas visibles para poder renderizarlas correctamente en la tabla */
    ListComponent.prototype.checkVisibleColumns = function () {
        this.visibleColumns = [];
        for (var i = 0; i < this.columns.length; i++) {
            if (this.columns[i].visible == true) {
                this.visibleColumns.push(this.columns[i].name);
            }
        }
        this.columnLoaded = true;
    };
    ListComponent.prototype.filter = function (list) {
        var _this = this;
        for (var key in this.filters) {
            if (this.filters.hasOwnProperty(key) && this.filters[key] != null && this.filters[key].length != 0) {
                switch (key) {
                    case 'desk_id':
                        this.filters[key] = parseInt(this.filters[key]);
                        list = list.filter(function (q) { return q[key] == _this.filters[key]; });
                        break;
                    case 'prekind_id':
                        this.filters[key] = parseInt(this.filters[key]);
                        list = list.filter(function (q) { return q[key] == _this.filters[key]; });
                        break;
                    default:
                        list = list.filter(function (q) { return q[key] == _this.filters[key]; });
                        break;
                }
            }
        }
        return list;
    };
    ListComponent.prototype.openModalFilter = function () {
        this._modal.show('filterModal');
    };
    ListComponent.prototype.applyFilters = function (event) {
        this.filters["clientname"] = event.target.clientname.value;
        this.filters["clientid"] = event.target.clientid.value;
        this.filters["label"] = event.target.label.value;
        this.filters["desk_id"] = event.target.desk_id.value;
        this.filters["prekind_id"] = event.target.prekind_id.value;
        this.filters["planhour"] = event.target.planhour.value;
        localStorage.setItem("filters", JSON.stringify(this.filters));
        this.isFiltered = true;
        this.getTurnList();
        this._modal.hide("filterModal");
    };
    ListComponent.prototype.clearFilters = function () {
        this.filters = {
            clientname: "",
            clientid: "",
            label: "",
            desk_id: "",
            prekind_id: "",
            planhour: ""
        };
        this.isFiltered = false;
        localStorage.removeItem("filters");
        this.getTurnList();
        this._modal.hide("filterModal");
    };
    ListComponent.prototype.searchFilter = function () {
        this.listFilter = {
            $or: [{ label: this.search }, { clientid: this.search }, { clientname: this.search }, { planhour: this.search },
                { ccode: this.search }, { type: this.search }, { prekindname: this.search }, { task: this.search }, { initdatetime: this.search },
                { lastredirect: this.search }, { deskdatetime: this.search }, { deskname: this.search }, { rdcomment: this.search }
            ]
        };
        localStorage.setItem("search", this.search);
    };
    ListComponent.prototype.removeSearch = function () {
        this.search = "";
        localStorage.removeItem("search");
        this.searchFilter();
    };
    ListComponent.prototype.softLogout = function () {
        if (this.subscriptionClose != null)
            this.subscriptionClose.unsubscribe();
        if (this.subscriptionOpen != null)
            this.subscriptionOpen.unsubscribe();
        if (this.ioConnection != null)
            this.ioConnection.unsubscribe();
        this._bevent.close();
        this._chat.close();
        this._data.timeExceed = true;
    };
    return ListComponent;
}());
export { ListComponent };
